"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageVariants = void 0;
var _createVariant = require("../internal/createVariant");
var _getBackgroundColorForVariants = require("../internal/getBackgroundColorForVariants");
var _sanitizeUrlFromWrongParams = require("../internal/sanitizeUrlFromWrongParams");
/**
 * Function provides images urls base on the needs of the developer.
 * It allows to customize width, height and quality for each variant
 * and one background color for all variants.
 * @param entryData
 * @returns ImageVariant[]
 */
const getImageVariants = entryData => {
  if (!entryData?.url) {
    throw new TypeError('You need to provide a base url with entry data');
  }
  const baseUrl = new URL(entryData.url);
  const backgroundColor = (0, _getBackgroundColorForVariants.getBackgroundColorForVariants)(baseUrl, entryData.backgroundColor);
  (0, _sanitizeUrlFromWrongParams.sanitizeUrlFromWrongParams)(baseUrl);
  const variants = Object.values(entryData.params).filter(variant => Boolean(variant.width)).map(variant => (0, _createVariant.createVariant)({
    variant,
    baseUrl,
    backgroundColor,
    imageSizeMultiplier: entryData.imageSizeMultiplier,
    excludeWidthFromUrl: entryData.excludeWidthFromUrl,
    imageFormat: entryData.imageFormat
  }));
  return variants;
};
exports.getImageVariants = getImageVariants;
